import { unique } from "@exonn/utils";

export const getAccessedPropertyNames = ({
  callback,
  object,
}: {
  object: any;
  callback: (values: any) => any;
}): string[] => {
  const names: string[] = [];

  const proxy = new Proxy(object, {
    get(_: any, key: string) {
      names.push(key);
    },
  });

  callback(proxy);

  return unique(names);
};
